<template>
  <span>
    <!--b-form-group label-cols="3" label="Widget type">
      <b-form-input v-model="widget_type" label="Name" />
    </b-form-group-->
    <b-form-group label-cols="3" label="Name">
      <b-form-input
        v-model="field.name"
        label="Name"
        @change="setSnakeName('name', 'code')"
      />
    </b-form-group>
    <b-form-group label-cols="3" label="Code">
      <b-form-input @change="changeProp" label="Code" v-model="field.code" />
    </b-form-group>

    <b-form-group label-cols="3" label="">
      <b-form-checkbox @input="changeProp" v-model="field.required"
        >Required</b-form-checkbox
      >
    </b-form-group>

    <b-form-group label-cols="3" label="">
      <b-form-checkbox @input="changeProp" v-model="field.disabled"
        >Disabled</b-form-checkbox
      >
    </b-form-group>

    <b-form-group label-cols="3" label="" v-if="can_score">
      <b-form-checkbox @input="changeProp" v-model="field.has_score"
        >Has Score</b-form-checkbox
      >
    </b-form-group>

<!--    <b-form-group label-cols="3" label="For State">-->
<!--      <b-form-input @change="changeProp" label="For State" v-model="field.for_state" />-->
<!--    </b-form-group>-->
  </span>
</template>
<script>
import { FIELD_TYPES_BY_CODE } from "../field_types.js";

export default {
  name: "widget-common-props",
  model: {
    prop: "field",
  },
  props: {
    field: {
      type: Object,
      default: () => {},
    },
    fields: { type: Array, default: () => [] },
  },
  computed: {
    can_score: function () {
      if (this.field) {
        return FIELD_TYPES_BY_CODE[this.field.field_type].can_score;
      }

      return false; // assume NO.
    },
    widget_type: function () {
      return this.field.field_type + " widget";
    },
  },
  methods: {
    changeProp() {
      this.$emit("changeProp");
    },
    setSnakeName(from_field, to_field) {
      if (
        this.field[to_field] == null ||
        this.field[to_field] == "" ||
        this.field._newfield
      ) {
        this.field[to_field] = _.snakeCase(this.field[from_field]);
      }
      this.changeProp();
    },
  },
};
</script>
